Element       = require("lib/element")
BaseSlide     = require("views/base/slide")
device        = require("lib/device")
fitText       = require("lib/fit-text")
{ Analytics } = Application.actions()
{ getValidAncestor } = require("utils/messaging")
domtoimage    = require('dom-to-image.min.js')
videojs = require("video.js").default
require('video.js/dist/video-js.css');

class SlideView extends BaseSlide
  fitTextOnResize: true
  fitTextOnRender: true

  initialize: (@options) ->
    { @transform, @transition, @getBounds } = Element

    # LMS Preview React component passes a "interactable" query param.
    # This can disable autoplay for videos so that lessons with a video
    # as its first slide don't constantly autoplay on the course page.
    if @options.data?.autoplay and @options.notInteractable
      @options.data.autoplay = false

    @options.metadata ?= {}

  lock: (direction, bounce) ->
    @options.lock(direction, bounce)

  unlock: ->
    @options.unlock()

  next: (ms) ->
    if @options.isLastSlide
      Application.publish("event:completed") {}
      Application.publish("event:exit") {}
      Application.publish("lesson:exit") {}
    else
      @options.next(if _.isNumber(ms) then ms)
      @slideNext()

  prev: (ms) ->
    @options.prev(if _.isNumber(ms) then ms)

  # Shortcut method to track events. The name of the slide is appended to the
  # category to ensure that events are nicely grouped by GA.
  trackEvent: ({category, action, label, value}) ->
    category += " - #{@getTrackingTitle()}" if @getTrackingTitle()
    Analytics.trackEvent category, action, label, value

  getTrackingTitle: ->
    @el.dataset.title or @el.id

  # View states are saved to `@currentState` and applied as a "#{key}-#{state}"
  # class on the slide for convenient transitioning between screen content.
  # eg "&.game-outro", "&.paused-true", "&.state-touched". False states will
  # not be added, but will remove the previous state.
  setState: (state, key = "state") ->
    @currentState ?= {}

    if state is "touched" and @currentState[key] is "narration"
      @hasInteracted = true

    else
      @el.classList.remove "#{key}-#{@currentState[key]}"

      if state is false
        delete @currentState[key]
      else
        @el.classList.add "#{key}-#{@currentState[key] = state}"

  # Get and set DOM/Zepto elements into the `@elements` dictionary to prevent
  # unecessary DOM queries. Fail silently by storing an empty element.
  setEl: (el, key) ->
    @elements ?= {}
    @elements[key] = el or document.createElement("div")

  # Try and fail silently when getting empty elements, given that a warning for
  # these has already been posted.
  getEl: (key) ->
    @elements?[key]

  # Render isn't called for normal slides, but may be required if we use a
  # template as a component on the page. Try to maintain the fit text font size
  # from the previous run-through, and debounce the new fitting if we're
  # refreshing the slide.
  render: ->
    data = _.extend(@serialize())

    # For BrainBoost, if there is a lessonHeaderTitle we want to change the lesson-header to display the new lesson for this slide.
    if data.lessonHeaderTitle?
      document.querySelector('#lesson-header-title-content strong').innerText = data.lessonHeaderTitle
    @el.innerHTML = (@template or @templates?.default)?(data)

    @setState("prompt") unless @ignoreStateOnRefresh
    @setEl(@el.querySelector(".narration-progress-bar"), "narration-progress")

    if @fixTextFontSize
      @el.querySelector(".content-fit")?.style.fontSize = @fixTextFontSize

    if @fitTextOnRender
      if @currentState?.refresh
        window.clearTimeout @fitTextTimeout
        @fitTextTimeout = window.setTimeout (=> @fitText()), 120
      else
        @el.classList.remove("active")
        @fitText =>
          window.setTimeout (=> @el.classList.add("active")), 300
    
    # Preload every media on the page
    @preloadMedia()

    isAdminTool = window.ED_LMS_PREVIEW

    if data.hasNarration and not window.ED_PUBLIC_PREVIEW
      if !isAdminTool
        @showLoadingNarration()
      if data.narration?.can_not_be_skipped is true
        document.querySelector('#play-audio-popup .btn-no')?.style.display = 'none'
      else
        document.querySelector('#play-audio-popup .btn-no')?.style.display = 'block'
    else
      document.getElementById('play-audio-popup')?.classList.remove("active")
      document.getElementById('play-audio-popup')?.ariaHidden = 'true';
      @hideLoadingNarration()

    if data.socialLearning?.enabled
      @trigger("ui", isSocial: true)
    else
      @trigger("ui", isSocial: false)
    Application.publish("event:slide-rendered") {}

  toggleLoadingNarration: (v) -> Backbone.Events.trigger("load-narration", v)
  showLoadingNarration: -> @toggleLoadingNarration(true)
  hideLoadingNarration: -> @toggleLoadingNarration(false)

  fitText: (done) ->
    if el = @el.querySelector(".content-fit")
      @_fitText?.cancel()
      @_fitText = fitText el, =>
        @$el.trigger("fittextend")
        @fixTextFontSize = el.style.fontSize
        done?()
    else
      done?()

  findOne: (selector) ->
    el = @el.querySelector(".content-fit")
    el?.querySelector(selector) or
    @el.querySelector(selector)

  findAll: (selector) ->
    el  = @el.querySelector(".content-fit")
    res = el?.querySelectorAll(selector)
    if res?.length > 0 then res else @el.querySelectorAll(selector)

  # Override Safari's annoying habit of not showing the content metadata,
  # like a poster for video or the length details for audio
  preloadMedia: ->
    update = (e) ->
      e.target.removeEventListener("timeupdate", update, false)
      e.target.pause()
      e.target.volume = 1

    for media in @el.querySelectorAll(".multi-content")
      if media.getAttribute("webkit-playsinline") and device.platform is "iOS"
        if media.nodeName is "AUDIO"
          media.volume = 0
          media.addEventListener("timeupdate", update, false)

      if media.nodeName is "VIDEO"
        trigger = => window.setTimeout (=> @trigger "resize"), 300
        @players ?= []
        player  = videojs(media, { fluid: true })
        player.one "error", ->
          # Let videoJS figure out which source to use
          player.src(player.currentSources())
        player.on "loadedmetadata", trigger
        player.on "play", => @trigger "video-play"
        player.on "pause", => @trigger "video-pause"

        @players.push player

        if device.platform is not "browser"
          player.on "fullscreenchange", =>
            if player.isFullscreen()
              Application.publish("event:rotation-unlock") {}
            else
              Application.publish("event:rotation-lock") {}

    if device.ios
      for iframe in @el.querySelectorAll(".multi-content-iframe iframe")
        if iframe.src.match(/\?/)
          iframe.src += "&forceReloadForAppContext=true"
        else
          iframe.src += "?forceReloadForAppContext=true"

  stopMedia: ->
    # exit any video in picture-in-picture mode from the current slide
    if document.pictureInPictureElement
      document.exitPictureInPicture() if document.exitPictureInPicture?

    for media in @el.querySelectorAll("audio, video")
      media.pause() unless media.paused

    for iframe in @el.querySelectorAll("iframe")
      iframe.parentNode.removeChild(iframe)

  # Construct the locals object which is passed to templates. Override
  # `serialize` for custom data filtering and parsing.
  serialize: ->
    narrationCannotBeSkipped = if @options.data?.waypoints then false else @options.data?.narration?.can_not_be_skipped
    starsEnabled = __?.slidedeck?.enableStars or @options.enableStars
    locals =
      # This is for BrainBoost, to allow dynamic switching of lesson titles in the lesson-header
      lessonHeaderTitle: @options.lessonTitle
      width: @el.offsetWidth
      height: @el.offsetHeight
      config: @options.config()
      hasPrompt: @options.data?.prompt?
      hasNarration: !@options.withoutNarration and @options.data?.narration?.audio_file
      hasStars:
        starsEnabled and @options.data?.challenge_configuration?.nb_stars > 0
      scorm: @options.scorm
      contextRequiresExitButton: @options.contextRequiresExitButton
      doneText: @options.data?.doneText || window.i18n("buttons.done")
      narration: _.extend(@options.data?.narration, { can_not_be_skipped: narrationCannotBeSkipped })

    _.extend({}, @options.data, locals, { metadata: @options.metadata })

  # Templates should override this function to reset themselves to an
  # initial state
  onRefresh: ->
    @show?()

  onNarrationLoaded: -> @hideLoadingNarration()

  onNarrationRejected: ->
    @hideLoadingNarration()

  # Show progress of audio, and try to animate it at smooth intervals
  onNarrationProgress: (progress) ->
    interval = if progress is 0 then 0 else (Date.now() - @narrationTimestamp)

    @transform @getEl("narration-progress"),
      scale: "#{progress}, 1"
      transition: "transform #{interval}ms linear"

    @getEl("narration-progress")?.offsetLeft

    @narrationTimestamp = Date.now()

  # When narration is finished, set the state according to the user's
  # interaction, which can be configured for each view.
  onNarrationComplete: ->
    if @hasInteracted
      delete @hasInteracted
      @setState("")
      @setState("touched")
    else if @currentState.state is "narration"
      @setState("prompt")

  # Teardown of elements or listeners which will not be garbage collected
  hide: ->
    # Dispose players to prevent funky things happening with videoJS on IE11
    if @players?
      for p in @players when p?.dispose?
        p.dispose()
      @players = []

  delegateEvents: ->
    super()

    @on("resize", @fitText, this) if @fitTextOnResize

  screenshot: ->
    if @options.data.answer?
      new Promise (resolve, reject) =>
        @collateScreenshots()
          .then((images) =>
            @trigger "complete", this, { isCorrect: true }
            @collateScreenshots(images)
          )
          .then(resolve)
          .catch(reject)
    else
      @collateScreenshots()

  collateScreenshots: (images = []) ->
    new Promise (resolve, reject) =>
      window.setTimeout ->
        domtoimage
          .toJpeg(window.document.body, {
            ignoreImageErrors: true
            dpi: 200
            quality: 0.8
            filter: (e) ->
              e?.tagName isnt "IMG" or not e?.src?.match("img.youtube.com/vi/")
          })
          .then((src) -> resolve([images..., src]))
          .catch((err) -> reject(err))
      , 200

  sendAudioTemplateAudio: (currentSrc, isWaypoint) ->
    Application.publish("event:current-audio-src-changed") { currentSrc, isWaypoint }
    if @options.scorm
      Backbone.Events.trigger "scorm:current-audio-src-changed", { currentSrc, isWaypoint }

    targetOrigin = getValidAncestor()
    window.parent?.postMessage({ type: 'event:current-audio-src-changed', payload: { currentSrc, isWaypoint } }, targetOrigin) unless !targetOrigin

module.exports = SlideView
